export default __webpack_public_path__ + "static/team-member-katsuyagoto-278c1493444273f6fc6efe7ee87da056.png";